$('#popup-post').on('show.bs.modal', function () {

    $('#productDetailModal').modal('hide');
    $('.mfp-product').click();

});

$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

$('#popup-post form').on('submit', function (e) {
    e.preventDefault();

    var el_form = $(this),
        formData = $(this).serializeObject(),
        el_button = $(this).find('button');

    App.prototype.loadingButton(el_button, false);

    $.ajax({
        type: 'POST',
        url: $(this).attr('action'),
        dataType: "json",
        data: {form: formData},
        success: function (response) {

            $('#popup-post').modal('hide');
            $('#popup-post-complete').modal('show');

            el_form.trigger('reset');

        },
        complete: function () {

            App.prototype.loadingButton(el_button, true);

        }

    });

});
